(function() {
  // Photos anglaises des variantes : s'applique quand le client choisit vraiment une variante.
  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
      var data = event && event.data;
      if (!data || !data.variant) return;
      var sectionId = data.sectionId;
      var dataScript = document.getElementById('en-variant-data-' + sectionId);
      if (!dataScript) return;
      var variantData = {};
      try { variantData = JSON.parse(dataScript.textContent); } catch (e) { return; }
      var src = variantData[String(data.variant.id)];
      if (!src) return;
      setTimeout(function() {
        var gallery = document.querySelector('#MediaGallery-' + sectionId + ' .product__media-list');
        var firstSlide = gallery && gallery.querySelector('.product__media-item');
        var img = firstSlide && firstSlide.querySelector('img');
        if (img) { img.removeAttribute('srcset'); img.src = src; }
      }, 300);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
